import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTenders = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 70,
	height: 70,
	viewBox: "0 0 70 70",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.772461 69.2478V67.0248H44.0183V69.2478H0.772461ZM25.1235 45.9071L6.02663 26.8103L10.4725 22.1624L29.7714 41.2592L25.1235 45.9071ZM46.3423 24.6884L27.2454 5.38944L31.8933 0.943604L50.9902 20.0405L46.3423 24.6884ZM67.6621 64.1957L18.1516 14.6853L19.7683 13.0686L69.2787 62.579L67.6621 64.1957Z",
		fill: "#152A58"
	})
});
export default SvgTenders;
